
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import defaultImage from "../../Assets/image 880.png";
import { useNavigate } from "react-router-dom";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { trackEvent, useGaTrackingConfig } from "../Utility/Utility";
import { encryptURLParam } from "../../Common/Axios/encrypt";

const ShopByCategoryOptimized = () => {
  const navigate = useNavigate();
  const [finalData, setFinalData] = useState([]);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const translation = getTranslationData();
  const gaTrackingConfig = useGaTrackingConfig();
  const categoryAllData = useSelector(
    (state) => state.userRoleSliceReducer.categoryData
  );
  const scrollContainerRef = useRef(null);

  const shouldDisplayInCategoriesSection = (category) => {
    const visibility = String(category?.visibility || "")
      .toLowerCase()
      .replace(/[^a-z]/g, "");
    if (visibility) {
      return (
        visibility === "both" ||
        visibility === "categoriessectiononly" ||
        visibility === "categoryonly" ||
        visibility === "categoriesonly" ||
        visibility.includes("categoriessection")
      );
    }
    return category?.displayHeader === false;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (categoryAllData) {
      const displayData = categoryAllData
        .filter(shouldDisplayInCategoriesSection)
        .sort((a, b) => a.displayOrder - b.displayOrder);
      setFinalData(displayData);
    }
  }, [categoryAllData]);

  const handleImageClick = (item) => {
    // Conditionally encrypt the categoryId parameter based on environment setting
    const categoryId = String(
      item?.id ?? item?.categoryId ?? item?.clientCategoryId ?? item?.value,
    );
    const finalCategoryId = process.env.REACT_APP_IS_E_E === 'false'
      ? categoryId
      : encryptURLParam(categoryId);

    const fullUrl = `${window.location.origin
      }/productlist?categoryId=${finalCategoryId}`;
    sessionStorage.setItem("ga4_item_list_name", `${item?.name} ${translation?.products}`);
    sessionStorage.removeItem("ga4_selected_promotion_name");

    trackEvent("category_viewed", {
      page_type: "home_page",
      client_code: gaTrackingConfig.trackingContext.client_code,
      platform_code: gaTrackingConfig.trackingContext.platform_code,
      title: item?.name,
      page_url: fullUrl,
      section_title: `${translation?.shopByCategory}`,

    });
    navigate(`/productlist?categoryId=${finalCategoryId}`, {
      state: { item },
    });
  };

  const handleScrollRight = () => {
    scrollContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };

  const handleScrollLeft = () => {
    scrollContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  const showDesktopArrows =
    Array.isArray(finalData) && finalData.length > 7 && !isMobileView;

  return (
    <>
      {finalData.length ? (
        <section className="py-xl-2 earn bg shopby_category_section">
          <div className="container">

            <div className="flex items-center justify-between">
              <h5 className="sec-below-head">{translation?.shopByCategory}</h5>
              {/* {Array.isArray(finalData) &&
                finalData.length > 1 &&
                isMobileView && (
                  <span className="view-all-cat">
                    <a
                      href="/productlist"
                    >
                      {translation?.viewAll || "View All"}
                      <i className="fa-solid fa-chevron-right"></i>
                    </a>

                  </span>
                )} */}
            </div>

            <div className="relative category-scroll-wrapper">
              {showDesktopArrows && (
                <>
                  <button
                    className="scroll-button1 scroll-left-category"
                    onClick={handleScrollLeft}
                    aria-label="Scroll categories left"
                  >
                    <i className="fa-solid fa-chevron-left"></i>
                  </button>
                  <button
                    className="scroll-button1 scroll-right-category"
                    onClick={handleScrollRight}
                    aria-label="Scroll categories right"
                  >
                    <i className="fa-solid fa-chevron-right"></i>
                  </button>
                </>
              )}

              <div
                className={`scrollbar-hide explore-section ${showDesktopArrows ? "with-scroll-controls" : ""}`}
                ref={scrollContainerRef}
              >
                {finalData.map((item, index) => (
                  <div
                    key={index}
                    className={`custom-img-bg ${isMobileView ? "mobile" : ""}`}
                  >
                    <div className="relative flex items-center justify-center cust-product">
                      <img
                        onClick={() => handleImageClick(item)}
                        style={{ cursor: "pointer" }}
                        className="cat-img"
                        alt={item?.name}
                        src={
                          item.image === "false"
                            ? defaultImage
                            : isMobileView
                              ? `${process.env.REACT_APP_CLIENT_URL}${item?.mobileImage}`
                              : `${process.env.REACT_APP_CLIENT_URL}${item?.image}`
                        }
                      />
                    </div>
                    <span className="mt-2 cat-name cat-shop">{item?.name}</span>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </section>
      ) : (
        ""
      )}
    </>
  );
};

export default ShopByCategoryOptimized;
